import React, {Component} from 'react';
import {Field, FieldArray, ErrorMessage, connect} from 'formik';
import {FormattedMessage, injectIntl} from 'react-intl';
import classNames from 'classnames';
import messages from '../../../../res/translations/messages';
import get from 'lodash/get';
import map from 'lodash/map';
import * as constants from '../../../constants';
import Expression from './Expression';
import ExpressionType from './ExpressionType';
import MinusButton from './MinusButton';
import Error from '../../Error';
import {previousQuestionsSupportingExpressions} from '../../../services/conditionBuilders';
import {stripHtml} from '../../../utils/text';

// TODO remove disable lint
/* eslint-disable react/jsx-no-bind */
class ExpressionContainer extends Component {
    constructor(props) {
        super(props);
        this.remove = this.remove.bind(this);
        this.removeGroup = this.removeGroup.bind(this);
        this.update = this.update.bind(this);
    }

    remove(index) {
        this.props.remove(index);
    }

    removeGroup() {
        this.props.remove(this.props.index);
    }

    update(e) {
        const {formik, name, index} = this.props;
        formik.setFieldValue(`${name}.${index}`, {
            id: e.target.value,
            logicOp: constants.LOGIC_OP_AND,
            condition: {operator: '', value: '', question: ''},
        });
    }

    render() {
        const {form, intl, name, k, index, previousPages, items} = this.props;
        const questions = previousQuestionsSupportingExpressions(previousPages);
        const extraFields = form.values.extraFields || this.props.extraFields;
        const parameters = form.values.parameters || this.props.parameters;

        return (
            <div className="pl-3 expression-container">
                {k.id !== undefined &&
                    <div className="d-flex">
                        <div className="flex-grow-1">
                            <label className="col-form-label" htmlFor={`${name}.${index}.id`}><FormattedMessage {...messages.jumps.label.source} /></label>
                            <div className="d-flex">
                                <Field name={`${name}.${index}.id`}
                                    className={classNames('form-control custom-select', {error: get(form.errors, `${name}.${index}.id`)})}
                                    component="select" onChange={this.update} >
                                    <option value="">{intl.formatMessage(messages.filters.select)}</option>
                                    {questions && questions.length > 0 &&
                                        <optgroup label={intl.formatMessage(messages.filters.questions)}>
                                            {questions.map((item, index) => (
                                                <option key={index} value={item.id}>{item.id} - {stripHtml(item.title || '')}</option>
                                            ))}
                                        </optgroup>}
                                    {extraFields && extraFields.length > 0 &&
                                        <optgroup label={intl.formatMessage(messages.filters.extraFields)}>
                                            {map(extraFields, (item, index) => (
                                                <option key={index} value={`extraFields.${item.name}`}>{item.name}</option>
                                            ))}
                                        </optgroup>}
                                    {parameters && parameters.length > 0 &&
                                        <optgroup label={intl.formatMessage(messages.filters.parameters)}>
                                            {map(parameters, (item, index) => (
                                                <option key={index} value={`parameters.${item.name}`}>{item.name}</option>
                                            ))}
                                        </optgroup>}
                                </Field>
                                <MinusButton className="ml-2" remove={this.remove} index={index} />
                            </div>
                            <div>
                                {get(form.errors, `${name}.${index}.id`) ? (
                                    <Error reason={get(form.errors, `${name}.${index}.id`).key} reasonParams={get(form.errors, `${name}.${index}.id`).params} />
                                ) : null}
                            </div>
                            {get(form.values, `${name}.${index}`) && get(form.values, `${name}.${index}`).id !== '' &&
                                <Field id={`${name}.${index}`} name={`${name}.${index}`}
                                    items={items} extraFields={extraFields} parameters={parameters}
                                    component={Expression} />
                            }
                        </div>
                    </div>
                }
                {get(form.values, name) && get(form.values, name)[index].id === undefined &&
                    <>
                        <FieldArray name={`${name}.${index}.conditions`}
                            render={(arrayHelpers) => (
                                <div key={index}>
                                    <Field name={`${name}.${index}.conditions`}
                                        items={items}
                                        extraFields={extraFields}
                                        parameters={parameters}
                                        component={ExpressionType}
                                        previousPages={previousPages}
                                        removeGroup={this.removeGroup}
                                        push={arrayHelpers.push}
                                        remove={arrayHelpers.remove}
                                    />
                                </div>
                            )}
                        />
                        <div>
                            {get(form.values, `${name}.${index}.conditions`) && get(form.values, `${name}.${index}.conditions`).length === 0 &&
                                <ErrorMessage name={`${name}.${index}.conditions`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            }
                        </div>
                    </>
                }
            </div>
        );
    }
}

export default connect(injectIntl(ExpressionContainer));
